export var NAVIGATION_MAX_DEPTH = 6;